<app-cv-template [isProduction]="isProduction" [mailServiceURL]="mailServiceURL" [showModal]="true"></app-cv-template>
